// extracted by mini-css-extract-plugin
export default {"cls1":"ContentFeedback-cls1__ac7ee781a7795ecd824a","cls2":"ContentFeedback-cls2__f3ed4b43be5f95e1162e ContentFeedback-cls1__ac7ee781a7795ecd824a"};